import React, { Component } from 'react'
import PlusIcon from '../icons/plusicon';
import FpgFilmTab from './../component/fpg/list/FilmListTable';
//Service import
import service from '../services'
import TalkEventListTable from '../component/fpg/list/TalkEventListTable';
import NewFrontierList from '../component/fpg/list/NewFrontierList';
import UploadImg from '../assets/images/cloud-data-upload-icon.svg'
import UploadImgicon from '../assets/images/upload_csv_icon.png'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'
import PartnerEventsList from '../component/fpg/list/PartnerEventsList';
import OtherEventsList from '../component/fpg/list/OtherEventsList';
import ScreeningsListTable from '../component/fpg/list/ScreeningsListTable';
import commonImage from '../commonImage';
import ErrorPopUp from '../component/errorPopUp';
import ScreeningsCsvUploadModal from './ScreeningsCsvUploadModal';

const mapStateToProps = state => ({
    currentTab: state.currentTab,
})
const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let sub
class FpgFilmList extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            activetab:0,
           showModalPopup: false,
           uploadCSVModal: false,
           totalAddedRecord: 0,
           fileUploading: false,
           totalSkippedRecord: 0,
           skippedUser: [],
            data:[
                {
                    "label":"FILMS",
                    "Content":"This is content for Tab 1",
                    "tabIndex":0,
                },
                {
                    "label":"EVENTS",
                    "Content":"This is content for Tab 2",
                    "tabIndex":1,
                },
                {
                    "label":"SCREENINGS",
                    "Content":"This is content for the Screenings tab",
                    "tabIndex":5,
                },
                {
                    "label":"NEW FRONTIER",
                    "Content":"This is content for Tab 3",
                    "tabIndex":2,
                },
                {
                    "label":"PARTNER EVENTS",
                    "Content":"This is content for Tab 4",
                    "tabIndex":3,
                },
                {
                    "label":"INSTITUTE EVENTS",
                    "Content":"This is content for Tab 5",
                    "tabIndex":4,
                }
            ]
        }
        this.apiserve = new service();
      }

      componentWillUnmount = () => {
        sub.unsubscribe();
    };

    TabClick = (index) => {
        this.setState({
            activetab:index
        },()=>{
            if(index === 0){
                this.props.filmEditData('')
                this.props.CurrentTab(0)
                this.props.history.push(`/filmlist`)
            }
            if(index === 1){
                this.props.TalkEventEditData('')  
                this.props.CurrentTab(1)
                this.props.history.push(`/filmlist`)
            }
            if(index === 2){
                this.props.NewFrontierEditData('')
                this.props.CurrentTab(2)
                this.props.history.push(`/filmlist`)
            }
            if(index === 3){
                this.props.PartnerEventsEditData('')
                this.props.CurrentTab(3)
                this.props.history.push(`/filmlist`)
            }
            if(index === 4){
                this.props.OtherEventsEditData('')
                this.props.CurrentTab(4)
                this.props.history.push(`/filmlist`)
            }
            if(index === 5){
                this.props.CurrentTab(5)
                this.props.history.push(`/filmlist`)
            }
        })
    }

    componentDidMount() {
        var callFrom = this.props.currentTab;

        if(callFrom)
        {
            this.setState({
                activetab: callFrom
            })
        }

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|screening|importScreeningsCSV":
                    if (!response.error) {
                        this.setState({
                            fileUploading: false,
                            totalAddedRecord: (response.data.totalProcessedRecords + response.data.totalUpdateRecords),
                            totalSkippedRecord: response.data.totalFailedRecords,
                            skippedUser: response.data.skipRecordArray
                        }, () => {
                            this.setState({
                                // successmodal: true,
                                uploadCSVModal: true
                            })
                        })
                        this.apiserve.sendevent("film|getList", {});
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "admin|screening|downloadCsv":
                    if (!response.error) {
                        window.open(response.data)
                        this.setState({
                            showModalPopup: false
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
            
                default:
                    break;
            }
        })
  }

  isShowPopup = (e,status) => {
    e.stopPropagation();
    this.setState({ showModalPopup: status });
  };

  onCancleFilter = () => {
    this.setState({
      showModalPopup: false
    })
  }

    AddPage = (index) => {
        if(index === 0){
            this.props.filmEditData('')
            this.TabClick(index)
             this.props.CurrentTab(index)
            this.props.history.push(`/create-film`)
        }
        if(index === 1){
            this.props.TalkEventEditData('')  
            this.TabClick(index)
             this.props.CurrentTab(index)
            this.props.history.push(`/create-film`)
        }
        if(index === 2){
            this.props.NewFrontierEditData('')
            this.TabClick(index)
             this.props.CurrentTab(index)
            this.props.history.push(`/create-film`)
        }
        if(index === 3){
            this.props.PartnerEventsEditData('')
            this.TabClick(index)
             this.props.CurrentTab(index)
            this.props.history.push(`/create-film`)
        }
        if(index === 4){
            this.props.OtherEventsEditData('')
            this.TabClick(index)
             this.props.CurrentTab(index)
            this.props.history.push(`/create-film`)
        }
    }
    
    downloadcsv = () => {
        this.apiserve.sendevent("admin|screening|downloadCsv", {});
    }


    uploadCSV = (e) => {
      let file = e.target.files[0];
      if ((file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') || file.name.includes('.csv') || (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
          this.setState({
              fileUploading: true
          })
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = (event) => {
              setTimeout(() => {
                  this.imageUploadScreen(file,false, event.target.result);
              }, 0);
          };
          e.target.value = ''
      } else {
          this.setState({ errorMsg: 'please upload .csv file only', errorPopup: true, fileUploading: false })
      }
  }

  imageUploadScreen = (file,IsFPGUpload=true,img) => {
      var fileSet = commonImage(file,IsFPGUpload, this.apiserve.formbucketCSV, img)
      fileSet.then((value) => {
          var data1 = {
              url: encodeURI(process.env.REACT_APP_IMAGE_URL + value)
          }
          this.apiserve.sendevent("admin|screening|importScreeningsCSV", data1);
      });
     
  };
  
  errorMsgPopup = () => {
    this.setState({
        errorPopup: false
    })
  }

  CloseModal = () => {
    this.setState({
        uploadCSVModal:false,
        showModalPopup: false
    })
  }

    render() {
        return (
            <React.Fragment>
                    <div className="right_side_wrapper">
                        <ul className={`fpg_admin_tab disp_flex${this.state.activetab === 5 ? ' fpg_admin_tab_screening' : ''}`}>
                            {
                                this.state.data && this.state.data.map((list) => {
                                    const index = list.tabIndex;
                                    if(list.label !== 'NEW FRONTIER' && list.label !== 'PARTNER EVENTS'){
                                        return(
                                            <li className={this.state.activetab === index ? 'active' : '' }>
                                               <p>
                                                  <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                  }} onClick={() => this.TabClick(index)}>
                                                    <div style={{ paddingRight: list.label === "SCREENINGS"  ? '0px' :'10px',position:'relative' }}>{list.label}</div>
                                                    {list?.label == "FILMS" ?
                                                       <div className="icon_block" onClick={(e) => this.isShowPopup(e,true)}>
                                                        <img src={UploadImgicon} style={{position:'absolute',right:'77px',bottom:'15px',width:'22px'}} />
                                                      </div> : ''
                                                    }
                                                  </div>
                                                    {list.label !== 'SCREENINGS' &&
                                                        <span id= {index} onClick={()=>this.AddPage(index)}><PlusIcon /></span>
                                                    }
                                                </p>
                                            </li>
                                        )
                                    }
                                })
                            }
                        </ul>
                       
                        <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                            <p></p>
                        </div>
                        {console.log(this.state.activetab,"this.state.activetab")}
                        {
                            this.state.activetab === 0 ?
                            <FpgFilmTab history={this.props.history}/>
                             : ''
                        }
                        {
                            this.state.activetab === 1 ?
                           <TalkEventListTable history={this.props.history}/>
                            : ''
                        }
                        {
                            this.state.activetab === 2 ?
                            <NewFrontierList history={this.props.history}/>
                            : ''
                        } 
                        {
                            this.state.activetab === 3 ?
                            <PartnerEventsList history={this.props.history}/>
                            : ''
                        }
                        {
                            this.state.activetab === 4 ?
                            <OtherEventsList history={this.props.history}/>
                            : ''
                        }
                        {
                            this.state.activetab === 5 ?
                            <ScreeningsListTable history={this.props.history}/>
                            : ''
                        }
                        {/* {
                            this.state.activetab === 3 ?
                            <PartnerEventsList history={this.props.history}/>
                            : ''
                        } */}

                        {/* {
                            this.state.activetab === 3 ?
                            <LiveScreening history={this.props.history}/>
                            : ''
                        } */}

                    </div>
                    
                     

                    

                    {this.state.showModalPopup && (
                      <div className='user_popup active'>
                        <span className="popup_overlay" onClick={this.onCancleFilter}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white overflow_initial fpg_csv_btn" >
                          <div className="approve_popup_header text_center relative pb_0  fpg_approve_popup">
                            <span className="close_popup fpg_close_popup" onClick={this.onCancleFilter}>
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.192 0.343994L5.949 4.58599L1.707 0.343994L0.292999 1.75799L4.535 5.99999L0.292999 10.242L1.707 11.656L5.949 7.41399L10.192 11.656L11.606 10.242L7.364 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                              </svg>
                            </span>
                            
                            <div className="head_btn pointer upload_pdf_btn" onClick={() => this.downloadcsv()}  style={{marginLeft:'17px',marginTop:'10px'}}>
                            <span className="upload_pdf"></span>
                               Download Sample</div>

                              <span className="head_btn pointer upload_pdf_btn"  style={{marginLeft:'17px',marginTop:'10px'}}><input type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={this.uploadCSV} className="upload_pdf" />Upload File <img src={UploadImg} style={{width:'19px',marginLeft:'5px',marginRight:'5px'}} />{this.state.fileUploading &&
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }</span>
                          </div>
                        </div>
                      </div>
                    )}

               {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

                 {/* For CSV upload successfully */}
                 <div className={`user_popup ${this.state.successmodal ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p>You have successfully uploaded {this.state.totalAddedRecord} users</p>
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="small_btn active" onClick={this.CloseModal}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.uploadCSVModal ? <ScreeningsCsvUploadModal CloseModal={this.CloseModal} totalAddedRecord={this.state.totalAddedRecord} totalSkippedRecord={this.state.totalSkippedRecord} skippedUser={this.state.skippedUser} /> : ''}

            </React.Fragment>    
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FpgFilmList)